import type { CityConfig } from "@/pages/city-template/types";

export const akronConfig: CityConfig = {
  city: "Akron",
  state: "Ohio",
  stateAbbr: "OH",
  slug: "akron",
  route: "/cities/akron",
  title: "Emergency Passport Akron, OH — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Akron, OH — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Summit County, the Cuyahoga Valley, and Northeast Ohio. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Akron, OH",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Akron and Summit County travelers — from Goodyear and Bridgestone executives to University of Akron polymer researchers to Cuyahoga Valley outdoor enthusiasts — get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Akron%20Ohio%20downtown%20skyline%20at%20golden%20sunset%20with%20the%20beautiful%20Cuyahoga%20Valley%20in%20the%20distance%2C%20modern%20and%20historic%20architecture%20bathed%20in%20warm%20amber%20light%2C%20green%20rolling%20hills%20visible%20beyond%20the%20city%2C%20the%20Lock%203%20park%20area%20with%20urban%20revitalization%2C%20professional%20cityscape%20photography%20wide%20panoramic%20view%2C%20vibrant%20Northeast%20Ohio%20atmosphere&width=1800&height=700&seq=akron-hero-2026&orientation=landscape",
  heroImageAlt: "Akron Ohio downtown skyline at golden sunset with the Cuyahoga Valley",
  geoPosition: "41.0814;-81.5190",
  geoPlacename: "Akron, Ohio",
  lastModified: "2026-06-14",
  vitalRecordsIcon: "ri-file-text-line",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St Suite 380, Chicago IL 60604",
    distance: "Approximately 350 miles, 5 hours via I-80",
  },
  nearbyCitiesZips: [
    { name: "Akron", zips: "44301–44399" },
    { name: "Cuyahoga Falls", zips: "44221, 44222, 44223" },
    { name: "Stow", zips: "44224" },
    { name: "Hudson", zips: "44236, 44237" },
    { name: "Fairlawn", zips: "44333" },
    { name: "Bath", zips: "44210" },
    { name: "Tallmadge", zips: "44278" },
    { name: "Kent", zips: "44240, 44241, 44242" },
    { name: "Barberton", zips: "44203" },
    { name: "Wadsworth", zips: "44281, 44282" },
    { name: "Medina", zips: "44256, 44258" },
    { name: "Canton", zips: "44701–44799" },
    { name: "Green", zips: "44232" },
    { name: "Norton", zips: "44203" },
    { name: "Uniontown", zips: "44685" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Akron departures — Detroit agency 2.5 hours away" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting with reserved submission slots" },
    { icon: "ri-map-pin-2-line", title: "Northeast Ohio Hub", desc: "Serving Summit, Portage, Medina, and Stark counties" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish — no chatbots" },
  ],
  testimonials: [
    {
      name: "Kevin D.",
      location: "Akron, OH",
      rating: 5,
      text: "Emergency passport for a last-minute trip to Toronto. Got it in 36 hours. Fast Passport Center kept me updated every hour. Outstanding service.",
      service: "Emergency Passport",
    },
    {
      name: "Patricia W.",
      location: "Cuyahoga Falls, OH",
      rating: 5,
      text: "Renewed my passport before our anniversary trip to Italy. Everything done online — delivered in 4 business days. Could not have been easier.",
      service: "Passport Renewal",
    },
    {
      name: "Brian T.",
      location: "Stow, OH",
      rating: 5,
      text: "Lost my passport 3 days before a business trip to Frankfurt. Fast Passport Center had a replacement ready in 30 hours. Absolute lifesavers — my Goodyear colleagues recommended them.",
      service: "Lost Passport",
    },
    {
      name: "Michelle K.",
      location: "Hudson, OH",
      rating: 5,
      text: "First passport for our 14-year-old headed to Costa Rica with her school. The team walked us through every step. Delivered on time with zero stress.",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "akron-1",
      name: "Akron Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "675 Wolf Ledges Pkwy",
      city: "Akron",
      state: "OH",
      zip: "44311",
      phone: "(330) 996-9630",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "South of downtown Akron",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Akron facility. Appointments required. Photo services available nearby. Convenient to University of Akron campus.",
      icon: "ri-mail-line",
    },
    {
      id: "akron-2",
      name: "Cuyahoga Falls Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2885 State Rd",
      city: "Cuyahoga Falls",
      state: "OH",
      zip: "44223",
      phone: "(330) 928-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "North Akron suburb",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Cuyahoga Falls, Stow, and Tallmadge residents. Less crowded than downtown Akron.",
      icon: "ri-mail-line",
    },
    {
      id: "akron-3",
      name: "Fairlawn Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "455 Ghent Rd",
      city: "Fairlawn",
      state: "OH",
      zip: "44333",
      phone: "(330) 668-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Northwest Akron suburb",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Fairlawn, Bath, and northwest Akron area. Less crowded than downtown. Good for business travelers.",
      icon: "ri-mail-line",
    },
    {
      id: "akron-4",
      name: "Kent Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "211 E Main St",
      city: "Kent",
      state: "OH",
      zip: "44240",
      phone: "(330) 673-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "East Akron area in Portage County",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Kent State University area and Portage County. Full passport services. Student-friendly — walk-ins sometimes available.",
      icon: "ri-mail-line",
    },
    {
      id: "akron-5",
      name: "Summit County Clerk of Courts",
      type: "Court Clerk Passport Acceptance",
      address: "209 S High St",
      city: "Akron",
      state: "OH",
      zip: "44308",
      phone: "(330) 643-2206",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Downtown Akron Courthouse",
      website: "https://www.summitoh.net/clerk",
      websiteLabel: "Summit County Clerk",
      notes: "Downtown Akron location. Good alternative to post office with earlier opening hours. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "akron-6",
      name: "Medina Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "340 W Liberty St",
      city: "Medina",
      state: "OH",
      zip: "44256",
      phone: "(330) 725-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Southwest Akron in Medina County",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Medina County and southwest Summit County residents.",
      icon: "ri-mail-line",
    },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Akron before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Akron for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround without the 2.5-hour drive to Detroit." },
    { q: "How fast can I renew my passport in Akron?", a: "Fast Passport Center offers fast passport renewal in Akron in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Akron?", a: "The Detroit Passport Agency is approximately 170 miles from Akron via I-80 and I-75 — about a 2.5-hour drive. However, Detroit requires appointments for life-or-death emergencies only and does not accept walk-ins. Fast Passport Center's courier service bypasses the appointment requirement entirely." },
    { q: "Do you serve the Cuyahoga Valley and Kent State area?", a: "Yes. Fast Passport Center serves the full Greater Akron region including Cuyahoga Falls, Stow, Hudson, Kent, Tallmadge, and the Cuyahoga Valley National Park area. Our overnight courier service works from any UPS location regardless of your specific Summit, Portage, or Medina county address." },
    { q: "Can I get a same-day passport appointment near Akron?", a: "Same-day passport appointments are not available at any passport agency within driving distance of Akron. The Detroit Passport Agency requires appointments for life-or-death emergencies only. For all urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest option for Summit County residents." },
    { q: "Do I need to drive to the Detroit Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. No 2.5-hour drive to Detroit — we save you a full day of travel." },
    { q: "Where do Akron travelers fly internationally?", a: "Akron travelers have several options: Cleveland Hopkins (CLE — 40 miles north, United hub with international routes), Akron-Canton (CAK — 20 miles south, domestic connections), and Pittsburgh (PIT — 100 miles southeast). For most international travel, Akron residents use CLE as their primary gateway." },
    { q: "Can Goodyear and Bridgestone employees get corporate expedited passports?", a: "Absolutely. We regularly serve Akron's corporate community — Goodyear, Bridgestone, FirstEnergy, and the polymer industry — for last-minute international business travel, factory visits in Asia and Europe, and global supply chain meetings. We understand corporate travel timelines and can coordinate multiple employee passports simultaneously." },
    { q: "Do you help University of Akron faculty and students?", a: "Yes. UA faculty presenting at international polymer science conferences, engineering researchers collaborating globally, and students studying abroad all use Fast Passport Center. The Detroit agency's 2.5-hour distance makes our courier service especially valuable for last-minute academic travel." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Akron", address: "990 E Market St, Akron, OH 44305", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — Cuyahoga Falls", address: "2751 State Rd, Cuyahoga Falls, OH 44223", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "FedEx Office — Akron", address: "3536 S Main St, Akron, OH 44319", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.fedex.com/" },
    { name: "Walmart Supercenter — Fairlawn", address: "2887 W Market St, Fairlawn, OH 44333", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/" },
    { name: "CVS Pharmacy — Stow", address: "4408 Kent Rd, Stow, OH 44224", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — Hudson", address: "5433 Darrow Rd, Hudson, OH 44236", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "CVS Pharmacy — Medina", address: "3443 Medina Rd, Medina, OH 44256", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "AAA Travel — Akron", address: "3601 Embassy Pkwy, Akron, OH 44333", hours: "Mon–Fri: 8AM–5:30PM", website: "https://www.aaa.com/" },
  ],
  dmvLocations: [
    { name: "Summit County BMV — Akron", address: "1030 E Tallmadge Ave, Akron, OH 44310", hours: "Mon–Fri: 8AM–5PM", note: "Driver's license and REAL ID services. Appointment recommended.", featured: true },
    { name: "Summit County BMV — Fairlawn", address: "2737 W Market St, Akron, OH 44333", hours: "Mon–Fri: 8AM–5PM", note: "Northwest Akron option. Typically shorter wait times. REAL ID available.", featured: false },
    { name: "Portage County BMV — Ravenna", address: "449 S Meridian St, Ravenna, OH 44266", hours: "Mon–Fri: 8AM–5PM", note: "Serves Kent, Portage County area residents.", featured: false },
    { name: "Medina County BMV", address: "210 Northland Dr, Medina, OH 44256", hours: "Mon–Fri: 8AM–5PM", note: "Serves Medina County and southwest Summit County residents.", featured: true },
  ],
  airports: [
    {
      code: "CAK",
      name: "Akron-Canton Airport",
      distance: "20 miles south of downtown Akron",
      address: "5400 Lauby Rd NW, North Canton, OH 44720",
      note: "Primary airport serving the Akron-Canton area. Good domestic connections with Southwest and other major carriers. Easier parking than Cleveland. Connecting through CAK to international gateways is common.",
      flightUrl: "https://www.akroncantonairport.com/",
      flightLabel: "CAK Airport",
      featured: true,
    },
    {
      code: "CLE",
      name: "Cleveland Hopkins International Airport",
      distance: "40 miles northwest of Akron",
      address: "5300 Riverside Dr, Cleveland, OH 44135",
      note: "Major international hub for Northeast Ohio. United hub with direct international flights to London, Dublin, Cancun, and the Caribbean. Preferred for long-haul international travel from the Akron area.",
      flightUrl: "https://www.clevelandairport.com/",
      flightLabel: "Cleveland Airport",
      featured: false,
    },
    {
      code: "PIT",
      name: "Pittsburgh International Airport",
      distance: "100 miles southeast of Akron",
      address: "1000 Airport Blvd, Pittsburgh, PA 15231",
      note: "Alternative international gateway with British Airways London service and additional European connections. About 1.5 hours via I-76.",
      flightUrl: "https://www.flypittsburgh.com/",
      flightLabel: "Pittsburgh Airport",
      featured: false,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Akron area flights. Detroit agency is 2.5 hours away, but our couriers handle the drive so you don't have to.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older. Perfect for Goodyear executives and UA faculty with conference travel.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support for Summit County residents.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation for Akron and Summit County residents.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support. We regularly help Summit County families with multi-child passport coordination.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes for Akron and Summit County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for Akron's polymer industry executives and Goodyear global supply chain managers who travel internationally while their primary passport is in visa processing.",
      bullets: ["Frequent traveler solution", "Backup during visa processing", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a water-damaged, torn, or significantly worn passport. Common for Akron business travelers who discover damage right before an international trip.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The wallet-size passport card for land and sea crossings to Canada, Mexico, Bermuda, and the Caribbean. Convenient for Akron travelers driving to Toronto (4.5 hours via I-90) or taking cruises from East Coast ports.",
      bullets: ["Wallet-size convenience", "Land and sea crossings to Canada", "Same expedited processing as book"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Akron OH", description: "Urgent passport processing for Akron Ohio travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Akron OH", description: "Fast passport renewal for Akron Ohio residents with a previously-issued passport." },
    { name: "First-Time Passport Akron OH", description: "New passport application services for Akron Ohio residents." },
    { name: "Child Passport Akron OH", description: "Minor passport services for Akron Ohio families with children under 16." },
    { name: "Second Passport Akron OH", description: "Second passport services for Akron polymer industry executives and frequent business travelers." },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Akron photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background. Even a slight shadow or off-white tint can cause rejection.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or wrong form type are the #1 rejection reasons at Summit County acceptance facilities. We review every form before you submit.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Akron applicants arrive with incorrect payment and must reschedule. We provide up-to-date fee schedules with every order.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Detroit regional agency will turn you away for emergency appointments. For our courier service, proof of travel is more flexible.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or provide notarized consent. This is a common issue for Summit County families where one parent travels for work — Goodyear and Bridgestone employees especially.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Akron travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel — the 2.5-hour Detroit drive is not a reliable backup plan.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from your Akron home, office, or UA dorm." },
    { number: "02", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Akron, Fairlawn, or Cuyahoga Falls." },
    { number: "03", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department — no rejection surprises." },
    { number: "04", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots — bypass the 2.5-hour Detroit drive." },
    { number: "05", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Akron address — trackable every step of the way." },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 350-mile, 5-hour drive to Chicago via I-80", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "Corporate Travel Expertise", agency: "No — generic service", fpc: "Yes — built-in polymer industry and corporate travel knowledge" },
    { feature: "Photo & Document Help", agency: "No guidance provided", fpc: "Yes — full document review included" },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Akron Residents",
    intro: "Akron's industrial heritage, polymer research ecosystem, and position between Cleveland and Canton create a distinctive set of passport timing challenges. Here's what Summit County travelers need to know.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "Cleveland Hopkins (CLE) — Northeast Ohio's Gateway",
        subtitle: "40 miles north, United Airlines hub with growing international service",
        description: "Cleveland Hopkins is the primary international airport for Akron residents — about a 40-minute drive via I-77. United operates year-round direct flights to London, seasonal service to Dublin and Cancun, plus daily connections through Newark, Chicago, and Washington Dulles. Air Canada, Frontier, and Spirit add additional domestic and limited international options. The airport's manageable size means shorter security lines than Chicago or Detroit, and parking is significantly cheaper.",
        tip: "CLE's international service is growing but limited. Many Akron travelers connect through United's Newark hub for European destinations. Make sure your passport is valid before booking — United's international award availability disappears fast.",
      },
      {
        icon: "ri-flight-takeoff-line",
        title: "Akron-Canton (CAK) — Your Backyard Airport",
        subtitle: "20 miles south, Southwest and budget carriers",
        description: "CAK is a genuine convenience for Akron travelers — 20 minutes from downtown, abundant parking at low rates, and Southwest Airlines connecting to virtually every major U.S. hub. While CAK has no direct international flights, it's the perfect starting point for domestic connections to international gateways. Many Akron business travelers use CAK for domestic legs before connecting internationally through BWI (Baltimore), ATL, or DEN.",
        tip: "Even for domestic connections at CAK, your passport is needed at check-in if your final destination is international. The airline verifies this before your first flight segment — you cannot fix a passport issue at your connecting hub.",
      },
      {
        icon: "ri-building-2-line",
        title: "Polymer Industry & Global Manufacturing",
        subtitle: "Goodyear, Bridgestone, and Akron's industrial legacy",
        description: "Akron remains a global hub for the polymer and tire industry. Goodyear's world headquarters, Bridgestone Americas' technical center, and dozens of polymer research firms create constant international travel. Executives visit tire factories in Thailand, rubber plantations in Indonesia, and automotive partners in Germany and Japan. UA's world-renowned polymer science program sends researchers to conferences across Asia and Europe. These trips are often booked with 1-3 weeks notice — creating a steady stream of expedited passport needs.",
        tip: "Goodyear and Bridgestone employees traveling to Asia must be especially aware of the 6-month passport validity rule. Many Asian countries require 6+ months of validity beyond your return date — even for a 3-day business trip.",
      },
      {
        icon: "ri-landscape-line",
        title: "Cuyahoga Valley & Outdoor Recreation Travel",
        subtitle: "National park enthusiasts going international",
        description: "The Cuyahoga Valley National Park — stretching from Akron to Cleveland — creates a strong outdoor recreation culture in Summit County. Hikers, cyclists, and kayakers who love the Towpath Trail and Brandywine Falls set their sights on international adventures: hiking the Alps, cycling through Tuscany, kayaking in Norway's fjords. Many are first-time international travelers who have never applied for a passport. The park's visitor center receives frequent questions about passport requirements from residents planning their first trip abroad.",
        tip: "Cuyahoga Valley outdoor enthusiasts planning international adventure trips should start passport applications at least 12 weeks before departure. Adventure tour operators often require passport copies at booking — not at departure.",
      },
    ],
    callout: {
      icon: "ri-flask-line",
      title: "University of Akron Research & Global Collaboration",
      description: "UA's College of Polymer Science and Polymer Engineering is one of the world's leading polymer research institutions. Faculty and graduate students regularly travel to international conferences in Germany, Japan, South Korea, and China. The Detroit Passport Agency's 2.5-hour distance makes expedited courier service essential for last-minute conference acceptances and research collaborations with fixed dates.",
    },
  },
  destinations: {
    title: "Where Akron Travelers Go — And Why Passports Get Urgent",
    intro: "Akron's polymer industry, university research ecosystem, and Northeast Ohio location shape the international destinations that create the most passport urgency.",
    stats: [
      { stat: "40%", label: "of Akron expedited requests are corporate or industry-related — Goodyear, Bridgestone, polymer sector" },
      { stat: "170 miles", label: "to Detroit Passport Agency — the closest regional agency via I-80/I-75" },
      { stat: "Mar–May", label: "peak season when spring polymer conferences and Q2 manufacturing travel collide" },
      { stat: "2.5 Hours", label: "drive to Detroit agency — avoided entirely with courier service" },
    ],
    destinations: [
      { name: "Germany", context: "Automotive industry partnerships, polymer conferences in Frankfurt and Düsseldorf, and Goodyear's European operations. CLE-Frankfurt seasonal direct flights or connections through Newark.", urgency: "Industry conference dates are fixed and unmovable — no flexibility on travel dates", icon: "ri-map-pin-2-line" },
      { name: "Japan & South Korea", context: "Bridgestone's Tokyo headquarters, automotive supplier meetings, and UA polymer research collaborations with Japanese and Korean universities.", urgency: "Asian business trips often booked 1-2 weeks out — 6-month passport validity rule critical", icon: "ri-map-pin-2-line" },
      { name: "Canada", context: "Toronto is just 4.5 hours via I-90. Business travel, family visits, and weekend getaways. Passport card ideal for land crossings at Niagara Falls or Detroit-Windsor.", urgency: "Passport card is perfect for Akron-to-Toronto road trips — cheaper and more convenient than passport book for land crossings", icon: "ri-map-pin-2-line" },
      { name: "United Kingdom", context: "CLE-London direct flights on United. Goodyear and polymer industry meetings, plus heritage tourism. Strong British-American industrial ties in Northeast Ohio.", urgency: "Business trips booked 2-3 weeks out with fixed meeting dates — expedited renewal essential", icon: "ri-map-pin-2-line" },
      { name: "Caribbean & Mexico", context: "CLE-Cancun direct flights plus cruise departures from East Coast ports. Popular with Akron families for spring break and all-inclusive resort vacations.", urgency: "Last-minute spring break bookings and cruise deals — passports discovered expired 1-2 weeks before departure", icon: "ri-map-pin-2-line" },
      { name: "Thailand & Southeast Asia", context: "Tire and rubber industry supply chain travel — visiting plantations, factories, and suppliers. Long-haul travel requiring careful passport and visa planning.", urgency: "Extended trips requiring multi-country visa coordination — second passport often needed", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other Ohio Service Areas",
    crossLinksDesc: "We serve travelers across the Buckeye State with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Cleveland", route: "/cities/cleveland" },
      { name: "Canton", route: "/cities/canton" },
      { name: "Columbus", route: "/cities/columbus-oh" },
      { name: "Ohio Overview", route: "/states/ohio" },
    ],
  },
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified Ohio birth certificates from the Ohio Department of Health Bureau of Vital Statistics. Available by mail, online, or in person at the Columbus office. Required for first-time passport applications.",
      url: "https://odh.ohio.gov/know-our-programs/vital-statistics",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified Ohio death certificates through ODH Vital Statistics. Mail, online, and in-person options available. Required for estate and legal matters.",
      url: "https://odh.ohio.gov/know-our-programs/vital-statistics",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request certified marriage certificates from the Summit County Probate Court at 209 S High St, Akron, OH 44308. Required for name change passport applications.",
      url: "https://www.summitoh.net/probate",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Summit County Clerk of Courts at 209 S High St, Akron, OH 44308. Required for name change passport corrections after divorce.",
      url: "https://www.summitoh.net/clerk",
    },
  ],
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Cleveland, OH", route: "/cities/cleveland" },
    { name: "Fast passport renewal in Canton, OH", route: "/cities/canton" },
    { name: "Emergency passport help in Columbus, OH", route: "/cities/columbus-oh" },
    { name: "Urgent passport services in Cuyahoga Falls", route: "/cities/cuyahoga-falls" },
    { name: "Same-day passport help in Kent, OH", route: "/cities/kent" },
    { name: "Passport courier services in Medina, OH", route: "/cities/medina" },
    { name: "Ohio passport services overview", route: "/states/ohio" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Akron remotely via secure courier. We do not have a walk-in office in Akron — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Summit County and Northeast Ohio travelers without the 2.5-hour drive to Detroit.",
  fpcOfficeAddress: "230 S Dearborn St Suite 380, Chicago IL 60604",
  fpcOfficeDistance: "Serving all of Summit County and the greater Northeast Ohio region",
  serviceAreaIntro: "From downtown Akron to the suburbs of Cuyahoga Falls, Stow, and Hudson, from Fairlawn to Kent and Barberton — Fast Passport Center serves the entire Greater Akron area. We regularly help travelers from Tallmadge, Wadsworth, and Medina get their passports fast. As the Rubber City's trusted passport courier, we understand the corporate and academic travel patterns that define Summit County.",
  nearbyCitiesIntro: "We serve all Akron neighborhoods and surrounding Northeast Ohio cities including Cuyahoga Falls, Stow, Hudson, Fairlawn, Bath, Tallmadge, Kent, Barberton, Wadsworth, Medina, and all the way to Canton. If you are anywhere in Summit, Portage, Medina, or Wayne counties, we have you covered.",
  howItWorksIntro: "Most Akron travelers complete everything online and ship documents overnight. No need to drive 2.5 hours to Detroit or wait in line at the regional agency.",
  mistakesIntro: "Akron travelers — from Goodyear executives to UA polymer researchers to Cuyahoga Valley outdoor enthusiasts — face unique passport challenges. Here are the most common mistakes we see.",
  testimonialsIntro: "Akron and Summit County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Akron? Here are the most common ones we hear from Summit County travelers.",
  statePageRoute: "/states/ohio",
  statePageName: "Ohio",
  dmvWebsite: "https://www.bmv.ohio.gov",
  dmvLabel: "Ohio BMV — Official Website",
};

export default akronConfig;